export function downloadCsv(csvString, filename) {
  let hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvString);
  hiddenElement.target = '_blank';
  hiddenElement.download = filename + '.csv';
  hiddenElement.click();
}

export function getFilenameUrl(url) {
  return url ? url.split('/').pop().split('#')[0].split('?')[0] : '';
}

export function validateUrl(url) {
  return url?.includes('http');
}
